<template>
  <section class="py-5" v-if="longArticle">
    <div class="container col-lg-9 mx-auto py-5">
      <div class="pt-5 col-10 mx-auto">
        <heading-one
          :text="longArticle.title"
          v-if="longArticle.title"
          class="font-poppins"
        />
        <paragraph-size-six
          :paragraph-text="longArticle.excerpt"
          class="py-5"
          v-if="longArticle.excerpt"
        />
        <div
          ref="contentDiv"
          v-html="longArticle.content"
          class="mt-5"
          v-if="longArticle.content"
        ></div>
        <div class="text-end fs-4" v-if="longArticle.created_at">
          <i>
            {{
              new Date(longArticle.created_at).toLocaleDateString("en-US", {
                month: "long",
                year: "numeric",
              })
            }}
          </i>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "SingleBlogLongArticle",
};
</script>
<script setup>
import { defineProps, watch, ref } from "vue";
import HeadingOne from "@/components/base-components/HeadingOne";
import ParagraphSizeSix from "@/components/base-components/ParagraphSizeSix";

defineProps({
  longArticle: {
    type: Object,
  },
});
const contentDiv = ref(null);

watch(contentDiv, (newValue, oldValue) => {
  if (newValue && newValue !== oldValue) {
    const imgs = contentDiv.value.querySelectorAll("img");
    imgs.forEach((img) => {
      img.style.width = "100%";
      img.style.height = "100%";
    });
  }
});
</script>

<style scoped></style>
